import ReactGA from "react-ga4";
import { pushToDataLayer } from "./gtm";

// Directly export the trackEvent function
export const trackEvent = (event: any, payload: any) => {
  pushToDataLayer(event, payload);

  if (payload?.user_id) {
    ReactGA.set({ user_id: payload.user_id });
  } else {
    ReactGA.set({ user_id: payload.cookie_id });
  }

  ReactGA.event({
    category: payload?.category,
    action: event,
    label: payload?.label || "",
    value: payload?.slug || payload?.label || "",
  });
};

export const handleGtmClick = (
  label: string,
  payload: any,
  eventName: string = "generic_click"
) => {
  const fullPayload = {
    label,
    ...payload,
  };

  trackEvent(eventName, fullPayload);
};